import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mapQueueTimeAreatoName } from "@mappings/mapQueueTimeAreatoName";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import NoDataAvailable from "@components/NoDataAvailable/NoDataAvailable";
import Spinner from "@components/Spinner/Spinner";
import { useDatePickerContext } from "@contexts/DatePickerContext";
import { useIataContext } from "@contexts/IataContext";
import { getPaxQueueTimes } from "../services";
import "./QueueTimeSummary.scss";
function formatWaitTimes(seconds) {
    if (seconds === undefined || isNaN(seconds) || seconds < 0) {
        return "-";
    }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}m ${remainingSeconds}s`;
}
function getTimeWarningClass(seconds, type) {
    const warningClass = "queuetime-summary-row-time-warning";
    if (seconds === undefined || isNaN(seconds) || seconds < 0) {
        return "";
    }
    const minutes = Math.floor(seconds / 60);
    if (type === "security" && minutes > 15)
        return warningClass;
    if (type === "emigration" && minutes > 15)
        return warningClass;
    if (type === "immigration" && minutes > 30)
        return warningClass;
    return "";
}
export const QueueTimeSummary = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { picker: { from, to }, } = useDatePickerContext();
    const { t } = useTranslation();
    const { iata } = useIataContext();
    const { data: queueTimes, isLoading: isLoading } = useQuery({
        queryFn: () => getPaxQueueTimes({
            iata: iata,
            from,
            to,
            interval: "day",
        }),
        queryKey: ["getPaxQueueTimes", { from, to, iata }],
    });
    if (isLoading)
        return _jsx(Spinner, {});
    if (!queueTimes)
        return _jsx(NoDataAvailable, {});
    return (_jsxs("div", { className: "queuetime-summary", children: [((_c = (_b = (_a = queueTimes === null || queueTimes === void 0 ? void 0 : queueTimes.intervals) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.security) === null || _c === void 0 ? void 0 : _c.length) > 0 && _jsxs("div", { className: "queuetime-summary-row", children: [_jsx("div", { className: "queuetime-summary-row-title", children: t("pax.widgets.queueTimes.security") }), (_f = (_e = (_d = queueTimes === null || queueTimes === void 0 ? void 0 : queueTimes.intervals) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.security) === null || _f === void 0 ? void 0 : _f.map((item, index) => (_jsxs("div", { children: [_jsx("div", { children: mapQueueTimeAreatoName(item.location) }), _jsx("div", { className: `queuetime-summary-row-time ${getTimeWarningClass(item.timeSecond, "security")}`, children: formatWaitTimes(item.timeSecond) })] }, index)))] }), ((_j = (_h = (_g = queueTimes === null || queueTimes === void 0 ? void 0 : queueTimes.intervals) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.emigration) === null || _j === void 0 ? void 0 : _j.length) > 0 &&
                _jsxs("div", { className: "queuetime-summary-row", children: [_jsx("div", { className: "queuetime-summary-row-title", children: t("pax.widgets.queueTimes.emigration") }), (_m = (_l = (_k = queueTimes === null || queueTimes === void 0 ? void 0 : queueTimes.intervals) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.emigration) === null || _m === void 0 ? void 0 : _m.map((item, index) => (_jsxs("div", { children: [_jsx("div", { children: mapQueueTimeAreatoName(item.location) }), _jsx("div", { className: `queuetime-summary-row-time ${getTimeWarningClass(item.timeSecond, "emigration")}`, children: formatWaitTimes(item.timeSecond) })] }, index)))] })] }));
};
